export const locale = {
  lang: 'tr',
  data: {
    'LEADER_GO': {
      'SECCION_SELECT_LEADER':{
        'TEX_CARGA_INFO':'Liderler yükleniyor',
        'TEX_FILT_INFO':'Filtreleme liderleri',
        'TEX_TITL_TAB1':'Liderlerin seçilmesi',
        'TEX_TITL_TAB2':'Seçili liderleri önizleyin',
        'TEX_TITL_TAB2_1':'Líderes guardados',
        'TEX_INDIC_1':'*Uygulanacak liderleri seçin',
        'TEX_INDIC_BUSQ':'Ad, e-posta veya alan girin',
        'TEX_BTN_FILT':'Filtre',
        'TH_1':'Lider adı',
        'TH_2':'Posta',
        'TH_3':'Alan',
        'TH_4':'Genero',
        'TH_5':'Año',
        'TH_6':'Tipo de trabajo',
        'TH_7':'CGO用户状态',
        'TH_EMA_LOCA':'Yer',
        'TH_EMA_SEND':'Gönderilen e-postalar',
        'TH_PUEST_LEAD':'Gönder',
        'STATUS_LOGIN_CGO':{
        'false':'etkin değil',
        'true':'Aktif',
        'undefined':'etkin değil',
        },
        'MODAL_ACTU_BAN_UNI':'Seçilen lider ekleniyor',
        'MODAL_ACTU_BAN_MUL':'Seçilen liderler ekleniyor',
        'WARNI_NO_SELEC':'Hiçbir lider seçilmediği için adım henüz tamamlanamıyor',
        'COMFI_COMP_PAS':'Lider seçim adımını tamamladığınızdan emin misiniz?',
        'BTN_CONFI_OK':'Tamam',
        'BTN_CONFI_YES':'Evet',
        'BTN_CONFI_NO':'Hayır',
        'MODAL_CONFI_GUAR_LEA':'¿Está seguro de guardar los líderes seleccionados?',
        'BTN_GUAR_LEA':'Guardar líderes seleccionados',
        'BTN_ACT_LEA':'Actualizar líderes seleccionados',
        'MSN_INGR_COD':'<span> Davet e-postaları göndermek için kodu kırmızı metin kutusuna girin ',
         'MSN_INGR_COD2':'</span>',
         'MODAL_CONFI_SEND_MAIL':'E-postaları göndereceğinizden emin misiniz?',
         'MODAL_CONFI_ACTIV_USER_CGO':'Kullanıcıyı etkinleştirdiğinizden emin misiniz?',
         'MODAL_CONFI_DESACTIV_USER_CGO':'Kullanıcıyı devre dışı bırakmak istediğinizden emin misiniz?',
         'MSN_INGR_COD_ACTI_USER':'<span> Kullanıcıyı etkinleştirmek/devre dışı bırakmak için kırmızı kodu metin kutusuna girin ',
         'MODAL_ERR_COD':'Yerleştirilen metin eşleşmiyor',
         'WARNI_NO_SELEC_LEA':'Posta gönderebilmek için en az bir lider seçin',
         'BTN_SEND_MAIL':'Posta gönder',
         'BTN_CONFI_CONFIRMAR':'Onayla',
         'BTN_CONFI_CANCELAR':'İptal',
         'MOD_INFO_SEN_EMA':'E-posta gönderiliyor...',
         'SUCCE_SEN_EMA':'Doğru gönderildiler',
         'NO_LEAD_PRODUCT_ASO':'Bu ürünle ilişkili sertifika, lider kullanıcıları içermiyor.',
         'MOD_ACTI_USE_CGO': 'Kullanıcı durumunu etkinleştirin',
         'SUCCE_UPDA_STA_STA_USE': 'Başarılı oldu',

      },
      'SECCION_PROGRAMACION':{
        'MODAL_CONFI_COMPL':'Posta düzenleyici adımını tamamladığınızdan emin misiniz? ',
        'FECHAS':{
          'TITULO':'Tarihleri seçin',
         'BTN_TEXT':'Tarihleri seçin',
         'INSTRUC_TEXT':'Yapılandırma için uygun olan farklı tarihleri seçin ve kaydedin',
        },
        'CORREOS':{
          'TITULO':'İletişim mesajları',
         'BTN_TEXT':'İletişim mesajlarını görüntüle',
         'INSTRUC_TEXT':'Gönderilecek iletişim mesajlarını gözden geçirin',
          'TIPOS_CORREO':{
            'TIPO1_INVITA':{
              'TITULO': 'Davet mesajı',
               'DESCRIP': 'Bu, çağrının başlatıldığı gün liderlere gönderilen mesajdır',
            },
            'TIPO2_RECOR_NO_INI':{
              'TITULO':'Başlamamış liderlere mesaj',
               'DESCRIP':'Henüz başlamamış liderlere gönderilen hatırlatma mesajıdır',
            },
            'TIPO3_RECOR_NO_FINA':{
              'TITULO':'Henüz bitirmemiş liderlere mesaj.',
               'DESCRIP':'Anketlerine başlamış ancak henüz bitirmemiş liderlere gönderilen hatırlatma mesajıdır',
            },
          }
        },
        'MODAL_ACCIO':{
          'TIPO_ACCIO_FECH':{
            'TITU_TEXT1':'Yapılandırmak için uygun tarihlerin her birini seçin',
          }
        },
        'ETIQ':{
          'tag_name':'Liderin adı',
           'tag_codeCoupon':'Kupon kodu',
           'tag_productoId':'Ürün kimliği',
           'tag_nameCourse':'kursun adı',
        }
      },
      'TIP_EMAI': {
        'lanzamiento': 'Davetiye başlatma tarihi',
         'aviso1': 'Yayın öncesi (Anket başlatmadan önce ilk istem)',
         'aviso2': 'Lansman öncesi (Anket başlatmadan önceki ikinci istem)',
         'cierre': 'Kapanış tarihi',
         'recordatorio1': 'Henüz başlamamış olanlara hatırlatma gönderme tarihi',
         'recordatorio2': 'Hatırlatmayı tamamlamayanlara hatırlatma gönderme tarihi',
      },
      'SECCION_CONFIRM':{
        'BTN_CONFIRM_ENVIO':'Postalamayı onayla',
        'BTN_ENVIO_CONFIRM':'Posta onaylandı',
        'MODAL_COMPL_CONF':'Posta onayı adımını tamamladığınızdan emin misiniz?',
        'MODAL_WARNIN_CONF':'Adımı tamamlamak için postaların gönderilmesini onaylamanız gerekir.',
      },
      'SECCI_AVANCE':{
        'CARDS':{
          'PASO_1':{
            'TITULO':'İlerleme',
           'DESCRIP':'Liderlerin gelişimi',
           'BTN_1':'Sayım portalına git',
           'BTN_2':'',
          },
          'PASO_2':{
            'TITULO':'Hatırlatıcı',
           'DESCRIP':'Süreci henüz başlatmamış veya bitirmemiş liderlere hatırlatma',
           'BTN_1':'Hatırlatıcı',
           'BTN_2':'',
          }
        }
      },
    },
    'ACTION_GO':{
      'COLUMNAS':{
        'NameUser':'Ad',
        'email':'Posta',
        'Area':'Alan',
        'JobTitle':'Postalamak',
        'Localidad':'Konum',
        'NumberOfEmails':'Mail gönderildi',
         'Age':'Yıl',
         'Gneration':'Cinsiyet',
         'IdUser':'Kullanıcı Kimliği',
         'SurveyID':'Anket Kimliği',
         'keyUserlogin':'Şifre',
         'Pass_cgo':'Şifre',
      }
    }
  }
};
